export const categories = [
  {
    title: "Trending Now",
    movies: [
      {
        Title: "Inception",
        Year: "2010",
        Type: "movie",
        imdbID: "tt1375666",
        Poster: "https://m.media-amazon.com/images/I/51zUbui+gbL._AC_.jpg"
      },
      {
        Title: "Interstellar",
        Year: "2014",
        Type: "movie",
        imdbID: "tt0816692",
        Poster: "https://m.media-amazon.com/images/M/MV5BYzdjMDAxZGItMjI2My00ODA1LTlkNzItOWFjMDU5ZDJlYWY3XkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg"
      },
      {
        Title: "The Dark Knight",
        Year: "2008",
        Type: "movie",
        imdbID: "tt0468569",
        Poster: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwrthRR05nczNi2RCuYIw8Nk_MTxCZ1c-kHA&s"
      },
      {
        Title: "The Batman",
        Year: "2022",
        Type: "movie",
        imdbID: "tt1877830",
        Poster: "https://m.media-amazon.com/images/I/61BzdB3uhsL._AC_UF894,1000_QL80_.jpg"
      },
      {
        Title: "The Office",
        Year: "2005",
        Type: "series",
        imdbID: "tt0386676",
        Poster: "https://m.media-amazon.com/images/M/MV5BZjQwYzBlYzUtZjhhOS00ZDQ0LWE0NzAtYTk4MjgzZTNkZWEzXkEyXkFqcGc@._V1_.jpg"
      },
      {
        Title: "The Vampire Diaries",
        Year: "2009",
        Type: "series",
        imdbID: "tt1405406",
        Poster: "https://m.media-amazon.com/images/I/812YVXK9kvL.jpg"
      },
      {
        Title: "Spider-Man",
        Year: "2002",
        Type: "movie",
        imdbID: "tt0145487",
        Poster: "https://rukminim2.flixcart.com/image/480/640/xif0q/poster/p/j/d/medium-spider-man-new-wall-poster-spider-man-new-wall-poster-original-imagppqchhvx8rwz.jpeg?q=90"
      },
      {
        Title: "Avengers: Endgame",
        Year: "2019",
        Type: "movie",
        imdbID: "tt4154796",
        Poster: "https://m.media-amazon.com/images/I/81ExhpBEbHL._AC_SL1500_.jpg"
      }
    ]
  },

  {
    title: "Action Movies Sci-Fi",
    movies: [
      {
        Title: "Mad Max: Fury Road",
        Year: "2015",
        Type: "movie",
        imdbID: "tt1392190",
        Poster: "https://www.tallengestore.com/cdn/shop/products/23_e01e60c4-340d-475c-9e95-9150cd72be7f.jpg?v=1568967564https://m.media-amazon.com/images/I/71C8u8pBB0L._AC_SL1500_.jpg"
      },
      {
        Title: "John Wick",
        Year: "2014",
        Type: "movie",
        imdbID: "tt2911666",
        Poster: "https://i.pinimg.com/736x/1f/91/58/1f9158a564c7a97f29ccfb6b1b2f0d72.jpg"
      },
      {
        Title: "Mission Impossible: Fallout",
        Year: "2018",
        Type: "movie",
        imdbID: "tt4912910",
        Poster: "https://m.media-amazon.com/images/I/81p+xe8cbnL._AC_SL1500_.jpg"
      },
      {
        Title: "Dune",
        Year: "2021",
        Type: "movie",
        imdbID: "tt1160419",
        Poster: "https://m.media-amazon.com/images/I/61G3TAFVdSL._AC_UF894,1000_QL80_.jpg"
      },
      {
        Title: "Blade Runner 2049",
        Year: "2017",
        Type: "movie",
        imdbID: "tt1856101",
        Poster: "https://m.media-amazon.com/images/I/61tjn9zjaaL._AC_UF894,1000_QL80_.jpg"
      },
      {
        Title: "Doctor Strange",
        Year: "2016",
        Type: "movie",
        imdbID: "tt1211837",
        Poster: "https://m.media-amazon.com/images/I/61I4EcHDhBL._AC_UF894,1000_QL80_.jpg"
      },
      {
        Title: "Star Wars: The Force Awakens",
        Year: "2015",
        Type: "movie",
        imdbID: "tt2488496",
        Poster: "https://images-cdn.ubuy.co.in/634f34d537827a518126ed9e-poster-stop-online-star-wars-episode-vii.jpg"
      }
    ]
  },

  {
    title: "Romantic Movies",
    movies: [
      {
        Title: "La La Land",
        Year: "2016",
        Type: "movie",
        imdbID: "tt3783958",
        Poster: "https://m.media-amazon.com/images/I/81j4bDPgXQL._AC_UF894,1000_QL80_.jpg"
      },
      {
        Title: "The Notebook",
        Year: "2004",
        Type: "movie",
        imdbID: "tt0332280",
        Poster: "https://m.media-amazon.com/images/M/MV5BZjE0ZjgzMzYtMTAxYi00NGMzLThmZDktNzFlMzA2MWRmYWQ0XkEyXkFqcGc@._V1_.jpg"
      },
      {
        Title: "Before Sunrise",
        Year: "1995",
        Type: "movie",
        imdbID: "tt0112471",
        Poster: "https://images.justwatch.com/poster/91967506/s718/before-sunrise.jpg"
      },
      {
        Title: "Pride & Prejudice",
        Year: "2005",
        Type: "movie",
        imdbID: "tt0414387",
        Poster: "https://m.media-amazon.com/images/M/MV5BMTA1NDQ3NTcyOTNeQTJeQWpwZ15BbWU3MDA0MzA4MzE@._V1_.jpg"
      }
    ]
  }
];
